import { Box, Button, Checkbox, Collapse, Container, CssBaseline, FormControl, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, ListItemText, MenuItem, Modal, Select, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as yup from 'yup';
import RtlProvider from "../../../Components/RtlProvider";
import customtheme from "../../../themes";
import { RiDeleteBin5Fill } from "react-icons/ri";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import { TbEdit, TbPlaylistAdd } from "react-icons/tb";
import EnumMapper from "../../../EnumMapper";
import AddPackageEvent from "./AddPackageEvent";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ContextNotification, severitys } from "../../../App";
import EditPackageEvent from "./EditPackageEvents";
import staticData from "../../../data/StaticData";
import { GrCaretNext } from "react-icons/gr";
import { GrCaretPrevious } from "react-icons/gr";


const PackageDetail = ({ Step, Next, Pre, Finish, DefaultValues }) => {

    const { open, setOpen } = useContext(ContextNotification);
    const [title, setTitle] = useState(null);
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showError, setShowError] = useState(false);
    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({
    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

        resolver: yupResolver(schema),
    });


    useEffect(() => {
        resetForm();
        if (DefaultValues)
            FillDefaultValues();
    }, [Step]);

    const FillDefaultValues = () => {

        setTitle(DefaultValues.title);
        setEvents(DefaultValues.events);
    }

    const HandlePre = () => {
        const detailData = {
            "title": title,
            "events": events
        }
        Pre(detailData);

    }
    const HandelNext = () => {
        const detailData = {
            "title": title,
            "events": events
        }
        resetForm();
        Next(detailData);


    }
    const HandelFinish = () => {
        const detailData = {
            "title": title,
            "events": events
        }
        Finish(detailData);
        resetForm();
    }

    const HandleChangeTitle = (event) => {
        setTitle(event.target.value);
    }
    const onSubmit = () => {
    }

    const resetForm = () => {
        setShowError(false);
        setSelectedEvent(null);
        setShowAddEvent(false);
        setShowEditEvent(false);
        setTitle('');
        setEvents([]);
    }


    /////event
    const [showAddEvent, setShowAddEvent] = useState(false);
      const [showEditEvent, setShowEditEvent] = useState(false);
      const[selectedIndex,setSelectedIndex]=useState(null)
    const AddNewEvent = (eventData) => {
        var maxIndex = events.length > 0 ? Math.max(...events.map(a => { return a.index })) : 0;
        const newitem = {
            "index": maxIndex + 1,
            "value": eventData
        }
        setEvents([...events, newitem]);
        setShowAddEvent(false);
    }
const HandleEditEvent = (index) => {
        if ((showEditEvent)&&(selectedIndex===index)) {
            setShowEditEvent(false);
            setSelectedIndex(null);
        }
        else {
            setShowEditEvent(true);
            setSelectedIndex(index);
        }
    }
    const LocalUpdate=(index,eventdata)=>{
const updateditem = {
            "index": index,
            "value": eventdata
        }
         setEvents([...events.filter((e)=>e.index!==index), updateditem]);
        setShowEditEvent(false);
    }

    const RemoveEvent = (index) => {
        var newindex = 0;
        const newEvents = events.filter((a) => a.index !== index).sort((a, b) => a.index >= b.index ? 1 : -1).map((itm) => {
            newindex = newindex + 1;
            return {
                "index": newindex,
                "value": itm.value
            }
        });

        setEvents(newEvents);
    }

    const HandleAddEvent = () => {
        if (showAddEvent) {
            setShowAddEvent(false);
        }
        else {
            setShowAddEvent(true);
        }

    }


    return (
        <>
            <ThemeProvider theme={customtheme(customization)}>
                <Container maxWidth={false} style={{ padding: 20 }}  >
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <RtlProvider>
                            <Grid container spacing={1} >
        
                                <Typography component="h1" variant="h5" sx={{ display: "flex", mt: 2, ml: 2, alignItems: "center", fontSize: '19px' }}>{'روز ' + staticData.Recorder[Step]}</Typography>
                                <Grid item md={12} xs={12}>
                                    <TextField label="عنوان مرحله سفر" margin="normal" value={title} onChange={(e) => HandleChangeTitle(e)} sx={{ width: '40%' }}></TextField>
                                    {(title !== '') && <Tooltip title="افزودن رویداد سفر"><IconButton edge="end" sx={{ mt: 3 }} aria-label="افزودن رویداد سفر" onClick={() => { HandleAddEvent(); }}>
                                        <TbPlaylistAdd color='#4a148c' size={24} />
                                    </IconButton>
                                    </Tooltip>}
                                </Grid>
                            </Grid>
                            {(showAddEvent) && <AddPackageEvent Event={selectedEvent} AddPackageEvent={(data) => AddNewEvent(data)} />}
                             {(showEditEvent) &&(selectedIndex)&& <EditPackageEvent Events={events.filter((e)=>e.index===selectedIndex)} Refresh={resetForm} IsLocal={true} LocalUpdate={(index,data)=>LocalUpdate(index,data)} />}
                            {(events?.length > 0) &&
                                <Box style={{ display: 'flex', border: '1px solid gray', borderRadius: 7 }} sx={{ mt: 1 }}>
                                    <List sx={{ width: '100%' }} style={{overflowX: 'auto'}}>
                                        {events?.sort((a, b) => a.index >= b.index ? 1 : -1).map((itm) => {
                                            return (
                                                <ListItem key={itm.index} >
                                                    <Grid container spacing={1}>
                                                        <Grid item md={1} xs={2}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={'رویداد ' + staticData.Recorder[itm.index]} />
                                                        </Grid>
                                                        <Grid item md={2} xs={10}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={itm.value.description} />
                                                        </Grid>
                                                        <Grid item md={2} xs={12}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={itm.value.eventTypeText} />
                                                        </Grid>
                                                        <Grid item md={1}xs={4}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={itm.value.startT ? ' ساعت ' + itm.value.startT : ''} />
                                                        </Grid>
                                                        <Grid item md={1.5}xs={4}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={itm.value.fromCityText ? ' شهر ' + itm.value.fromCityText : ''} />
                                                        </Grid>
                                                        <Grid item md={1}xs={4}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={itm.value.endT ? ' ساعت ' + itm.value.endT : itm.value.endT} />
                                                        </Grid>
                                                        <Grid item md={1.5}xs={4}>
                                                            <ListItemText sx={{ ml: 1, mt: 1 }} primary={itm.value.toCityText ? ' شهر ' + itm.value.toCityText : ''} />
                                                        </Grid>

                                                        
                                                            <Grid item md={0.5} xs={2}>
                                                                <IconButton edge="end" aria-label="ویرایش" onClick={() => { HandleEditEvent(itm.index) }}>
                                                                    <TbEdit color='#4a148c' />
                                                                </IconButton>
                                                            </Grid>
                                                            <Grid item md={0.5}xs={2}>
                                                            <IconButton edge="end" aria-label="حذف" onClick={() => { RemoveEvent(itm.index) }}>
                                                                <RiDeleteBin5Fill color='#C7253E' />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>
                                                </ListItem>
                                            )
                                        })
                                        }
                                    </List>
                                </Box>}
                                 <Box style={{ display: 'flex',}} sx={{ mt: 1 }}>
                            {(Step > 1) &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                     style={{
                    fontSize: "20px",
                    width: "8rem",
                    height: "3rem",
                    backgroundColor: "#1898BD",
                    color: "white",
                    margin: 2
                  }}
                                    sx={{ m: 1 }}
                                    onClick={() => { HandlePre() }}
                                >
                                 <GrCaretNext size={24}/>
                                    روز قبل
                                </Button>}

                           {(events?.length>0)&&<> <Button
                                variant="contained"
                                color="primary"
                                style={{
                    fontSize: "20px",
                    width: "8rem",
                    height: "3rem",
                    backgroundColor: "#1898BD",
                    color: "white",
                    margin: 2
                  }}
                                sx={{ m: 1 }}
                                onClick={() => { HandelNext() }}
                            >
                                روز بعد
                                <GrCaretPrevious size={24}/>
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                style={{
                                        fontSize: "16px",
                                        width: "12rem",
                                        height: "3rem",
                                        margin: 2
                                    }}
                                sx={{ m: 1 }}
                                onClick={() => { HandelFinish() }}
                            >
                                پایان ثبت مراحل سفر

                            </Button>
                            </>}
                            </Box>
                            {(showError) && <p className="error">{' عنوان مرحله سفر را وارد کنید'}</p>}

                        </RtlProvider>
                    </form>

                </Container>
            </ThemeProvider>
        </>

    );
}
export default PackageDetail;